import { API_ENDPOINT, localStoragePrefix } from '../config'
import { DEFAULT_SETTINGS } from '../controllers/settings'
import { getPlayerId, getPlayed } from '../controllers/stats'
import apiFetch from '../util/apiFetch'
import Box from './Box'
import FeedbackMsgTemplate from './FeedbackMsgTemplate'
import React, { FunctionComponent } from 'react'

type FeedbackBoxProps = {
	milestone: number
}

const FeedbackBox: FunctionComponent<FeedbackBoxProps> = ({ milestone }) => {
	const feedbackType = `Day ${milestone}`
	const feedbackSentStorageKey = `${localStoragePrefix}feedbacksent_${milestone}`
	const [feedback, setFeedback] = React.useState('')
	const [feedbackSent, setFeedbackSent] = React.useState<boolean>(
		localStorage.getItem(feedbackSentStorageKey) === 'true' ||
			(milestone === 2 && localStorage.getItem('feedbacksent') === 'true')
	)

	const sendFeedback = () => {
		if (!feedback) return
		const data = {
			pid: getPlayerId(),
			value: feedback,
			showClock: DEFAULT_SETTINGS.showclock,
			milestone,
			type: feedbackType,
		}

		const url = `${API_ENDPOINT}/feedback`
		apiFetch(url, 'POST', data)
		setFeedbackSent(true)
		localStorage.setItem(feedbackSentStorageKey, 'true')
		if (milestone === 2) localStorage.setItem('feedbacksent', 'true')
	}

	if (getPlayed() !== milestone) return null

	if (feedbackSent) {
		return (
			<Box>
				<h2>Thank you for the feedback!</h2>
			</Box>
		)
	}

	const feedbackMessages = {
		2: {
			title: 'Thank you for playing!',
			msg: (
				<p>
					Did you enjoy it? &nbsp; I&apos;d appreciate any feedback you can provide,
					positive or negative!
				</p>
			),
		},
		30: {
			title: 'Day 30',
			msg: (
				<>
					<p>
						My word - 30 games already! Thank you so much for spending your time with
						One Word Search. It really does mean the world to me.
					</p>
					<p>
						I&apos;m always trying to make this little game even better, so if you have
						a moment, I&apos;d be so grateful if you shared your thoughts. Every kind
						word, helpful suggestion, and honest opinion helps shape what comes next.
					</p>
				</>
			),
		},
		100: {
			title: 'Day 100',
			msg: (
				<>
					<p>
						Good grief - 100 games of One Word Search! That&apos;s quite an achievement.
						Thank you for being such a wonderfully loyal player. It means more to me
						than words can say... well, for a word game, that&apos;s saying something!
					</p>
					<p>
						I do hope you&apos;re still enjoying One Word Search as much as ever. If
						you&apos;d be kind enough to share your thoughts, I&apos;d be absolutely
						delighted. Every thought you share helps make One Word Search even better.
					</p>
				</>
			),
		},
	}
	const message = feedbackMessages[milestone as keyof typeof feedbackMessages]

	return (
		<Box>
			<FeedbackMsgTemplate
				title={message.title}
				msg={message.msg}
				type={feedbackType}
				value={feedback}
				onChange={e => setFeedback(e.currentTarget.value)}
				onSend={sendFeedback}
			/>
		</Box>
	)
}

export default FeedbackBox
